<template>
  <OnboardingQuestion :title="question" :disabled="!answer" @next="handleClick">
    <SelectOption
      v-model="answer"
      :icon="PieChart0875Icon"
      value="It’s my primary income"
    >
      It’s my primary income
    </SelectOption>
    <SelectOption
      v-model="answer"
      :icon="PieChart0625Icon"
      value="Part of my income"
    >
      Part of my income
    </SelectOption>
    <SelectOption v-model="answer" :icon="PieChart0375Icon" value="A growing part">
      A growing part
    </SelectOption>
    <SelectOption
      v-model="answer"
      :icon="PieChart0125Icon"
      value="Not yet, but I’m working toward it"
    >
      Not yet, but I’m working toward it
    </SelectOption>
  </OnboardingQuestion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  PieChart0125Icon,
  PieChart0375Icon,
  PieChart0625Icon,
  PieChart0875Icon,
} from '@dacr/icons'

import OnboardingQuestion from '@/features/onboarding/components/OnboardingQuestion.vue'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'How does your creative work contribute to your income?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Four] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Four] = value
  },
})

const handleClick = () => {
  const answers = [answer.value]

  completeStep({ step: 4, question, answers })

  onboardingStore.goToNextStep({ question, answers })
}
</script>
